import {ListSubheader, styled} from '@mui/material';

const StyledListSubheader = styled(ListSubheader)`
	margin-top: 16px;
	padding: 0;
	background-color: transparent;
	color: ${({theme}) => theme.palette.text.primary};
`;

export {StyledListSubheader};
